import React, { PureComponent } from 'react'
import classNames from 'classnames'
import './Spinner.less'

export enum SpinnerSizeEnum {
  small = 'small',
  medium = 'medium',
  large = 'large'
}

export interface ISpinnerProps {
  size?: SpinnerSizeEnum
  progress?: number
}

/**
 * @deprecated
 * Use instead <Spinner/> from front-end/src/components
 */
export default class Spinner extends PureComponent<ISpinnerProps> {
  static defaultProps = {
    size: SpinnerSizeEnum.medium,
    progress: null
  }
  render() {
    const { props } = this

    const cssClasses = classNames('Spinner', `Spinner__${props.size}`, {
      Spinner__complete: props.progress === 100
    })

    return (
      <div className={cssClasses} data-test="Spinner">
        <div className="Spinner__line" />
        {props.progress && (
          <span className="Spinner__progress">
            {props.progress}
            <span className="Spinner__progressSign">%</span>
          </span>
        )}
      </div>
    )
  }
}
